import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import Icon from "../common/icon/icon.component.jsx"
import { AppContext, Features, AccountFeatures } from "@lightspeed-invoicing/core-client/frontend";
import GlobalHelper from "../common/GlobalHelper.jsx";
import { getPriceListName } from "../name-helpers/priceListNameHelper";
import { pascalCase } from '../name-helpers/nameFormatter';
import LinkTemplateWrapper from '../common/rich-text/feature-protection-wrappers/linkTemplateWrapper.component';

class DocumentTemplatesSection extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {}

    }

    componentDidMount() { }

    getLinks() {
        return ([
            {
                name: "quotes",
                to: "/templates/quote-template/listing",
                module: "",
                message: <FormattedMessage
                    id="settings.documents.template.quotes"
                    defaultMessage="Quote templates"
                />
            },
            {
                name: "contracts",
                to: "/templates/contract-template/listing",
                module: "",
                message: <FormattedMessage
                    id="settings.documents.template.contracts"
                    defaultMessage="Contract templates"
                />,
            },
            {
                name: "orders",
                to: "/templates/order-template/listing",
                module: AccountFeatures.FeatureOrder,
                message: <FormattedMessage
                    id="settings.documents.template.orders"
                    defaultMessage="Order templates"
                />
            },
            {
                name: "invoices",
                to: "/templates/invoice-template/listing",
                module: Features.Invoice,
                message: <FormattedMessage
                    id="settings.documents.template.invoices"
                    defaultMessage="Invoice templates"
                />,
            },
            {
                name: "price-lists",
                to: "/templates/price-list-template/listing",
                module: AccountFeatures.FeaturePriceList,
                message: <FormattedMessage
                    id="settings.documents.template.price_list"
                    defaultMessage="{priceList} templates"
                    values={{
                        priceList: pascalCase(getPriceListName(this.props.intl))
                    }}
                />
            },
            {
                name: "credit-memos",
                module: "",
                to: "/templates/credit-memo-template/listing",
                message: <FormattedMessage
                    id="settings.documents.template.credit_memo_receipts"
                    defaultMessage="Credit memo receipt templates"
                />
            },
            {
                name: "account-statements",
                to: "/templates/account-statement-template/listing",
                module: AccountFeatures.FeatureAccountStatements,
                message: <FormattedMessage
                    id="settings.documents.template.account_statements"
                    defaultMessage="Account statement templates"
                />
            },
            {
                name: "scheduling-pages",
                to: "/templates/scheduling-page-template/listing",
                module: AccountFeatures.FeatureScheduling,
                message: <FormattedMessage
                    id="settings.documents.template.scheduling_pages"
                    defaultMessage="Scheduling page templates"
                />
            },
            {
                name: "packing-slips",
                to: "/templates/packing-slip-template/listing",
                module: Features.Invoice,
                message: <FormattedMessage
                    id="settings.documents.template.packing_slips"
                    defaultMessage="Packing slips"
                />
            },
            {
                name: "snippet",
                to: "/templates/snippet/listing",
                module: "",
                message: <FormattedMessage
                    id="settings.documents.template.snippet"
                    defaultMessage="Snippet"
                />
            },
        ])
    }

    render() {
        const supportedDocuments = GlobalHelper.getSupportedDocuments()
        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="m-0 custom-lead">
                                    <FormattedMessage
                                        id='settings.documents.template.title'
                                        defaultMessage='Document templates'
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="row" style={{ paddingLeft: "20px" }}>
                            <div className="col-12 list-group">

                                {this.getLinks().filter(l => supportedDocuments.includes(l.name)).map((elem, index) => {
                                    return (
                                        <LinkTemplateWrapper
                                            key={index}
                                            module={elem.module}
                                            to={elem.to}
                                            redirectToAccount={true}
                                            className={"list-group-item"}
                                            protectedClassName={"list-group-item"}
                                            premium={false}
                                            protectionRule={elem.module === "" ? true : AppContext.accountFeatureIsEnabled(elem.module)}
                                        >
                                            <Icon value={"pencil-ruler"} className={'mr-1'} />
                                            {elem.message}
                                            <Icon value={"chevron-right"} />
                                        </LinkTemplateWrapper>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default injectIntl(DocumentTemplatesSection)


// WEBPACK FOOTER //
// ./src/template/section.component.jsx